import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  CardContent,
  Fab,
  FormControl,
  FormGroup,
  Grid,
  MenuItem,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import { Search } from "@material-ui/icons";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React from "react";
import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import datetimeHelper from "../../helper/datetime-helper";
import formatNumber from "../../helper/format-number";
import { globalHistory } from "../../history";
import { mapActionsToProps as agentAction } from "../../redux/agent";
import { mapActionsToProps as campaignAction } from "../../redux/campaigns";
import { mapActionsToProps } from "../../redux/report/campaign";
import Dialog from "./../../components/Dialog";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    justifyContent: "center",
    display: "flex",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
  toolbar: {
    paddingLeft: theme.spacing.unit,
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
});

class CampaignReportDetail extends React.Component {
  state = {
    value: 0,
    filters: {
      order: "createdAt DESC",
      where: {
        gte: null,
        lte: null,
      },
      page: 0,
      pageSize: 20,
    },
  };

  async componentDidMount() {
    const { filters } = this.state;
    this.history = globalHistory();
    this.itemInit();
  }

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "campaignId":
            case "groupId":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({ time: { gte: this.state.filters.where.gte } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.lte } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getListCampaigns(filters.order, 999, null, null);
  }

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = () => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState({ disable: false });
    let gte = datetimeHelper.toFormat(
      this.state.filters.where.gte,
      "YYYY-MM-DD startDay"
    );
    let lte = datetimeHelper.toFormat(
      this.state.filters.where.lte,
      "YYYY-MM-DD endDay"
    );
    this.props.campaignReportByDate(gte, lte, filters.where.campaignId);
  };

  handleDateChangeStart = (gte) => {
    const { filters } = this.state;
    filters.where.gte = datetimeHelper.toFormat(gte, "YYYY-MM-DD");
    this.setState({ gte });
  };

  handleDateChangeEnd = (lte) => {
    const { filters } = this.state;
    filters.where.lte = datetimeHelper.toFormat(lte, "YYYY-MM-DD");
    this.setState({ lte });
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes, listCampaignByAgent, listCampaignByDate, listCampaign } =
      this.props;
    const { filters } = this.state;
    const listCampaignByAgentResult =
      typeof listCampaignByAgent === "object"
        ? Object.keys(listCampaignByAgent).map(
            (key) => listCampaignByAgent[key]
          )
        : listCampaignByAgent;
    const listCampaignResult =
      typeof listCampaign === "object"
        ? Object.keys(listCampaign).map((key) => listCampaign[key])
        : listCampaign;
    const dataReportByAgent = [
      [
        "Mã nhân viên",
        "Mới",
        "Tiềm năng",
        "Cần gọi lại",
        "Không có nhu cầu",
        "Không làm phiền",
        "Không đủ điều kiện",
        "Sai khu vực",
        "Voice mail",
      ],
    ];
    const listCampaignByDateResult =
      typeof listCampaignByDate === "object"
        ? Object.keys(listCampaignByDate).map((key) => listCampaignByDate[key])
        : listCampaignByDate;
    for (const key in listCampaignByAgentResult) {
      if (listCampaignByAgentResult.hasOwnProperty(key)) {
        const value = listCampaignByAgentResult[key];
        if (value.agent.agentCode !== "Total") {
          dataReportByAgent.push([
            value.agent.agentCode,
            value.new,
            value.ptp,
            value.callback,
            value.ni,
            value.dnd,
            value.nmq,
            value.wr,
            value.vm,
          ]);
        }
      }
    }
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                      <Grid item md={3}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Tên chiến dịch"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.campaignId}
                          name="campaignId"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}>
                          {listCampaignResult
                            ? listCampaignResult.map((item, key) => {
                                return (
                                  <MenuItem key={key} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </SelectValidator>
                      </Grid>

                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.gte}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="gte"
                          keyboard
                          ampm={false}
                        />
                      </Grid>
                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian kết thúc"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.lte}
                          maxDate={new Date()}
                          minDate={filters.where.gte}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeEnd}
                          name="lte"
                          keyboard
                          ampm={false}
                        />
                      </Grid>
                      <Grid item md={3}>
                        <Fab
                          color="primary"
                          aria-label="Search"
                          className={classes.fab}
                          // onClick={this.handleSubmit}
                          type="submit">
                          <Search />
                        </Fab>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>

        <Paper square style={{ marginTop: 15 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell
                  rowSpan="2"
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Ngày
                </TableCell>
                <TableCell
                  rowSpan="2"
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tổng số cuộc kết nối
                </TableCell>
                <TableCell
                  colSpan="2"
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  Chưa tương tác
                </TableCell>
                <TableCell
                  colSpan="2"
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  Đạt điều kiện
                </TableCell>
                <TableCell
                  colSpan="2"
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  Hẹn gọi lại
                </TableCell>
                <TableCell
                  colSpan="2"
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  Không có nhu cầu
                </TableCell>
                <TableCell
                  colSpan="2"
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  Không đủ điều kiện
                </TableCell>
                <TableCell
                  colSpan="2"
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  Sai location
                </TableCell>
                <TableCell
                  colSpan="2"
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  Voice Mail
                </TableCell>
                <TableCell
                  colSpan="2"
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  Không làm phiền
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tổng số
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tỉ lệ (%)
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tổng số
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tỉ lệ (%)
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tổng số
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tỉ lệ (%)
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tổng số
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tỉ lệ (%)
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tổng số
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tỉ lệ (%)
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tổng số
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tỉ lệ (%)
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tổng số
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tỉ lệ (%)
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tổng số
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tỉ lệ (%)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listCampaignByDateResult
                ? listCampaignByDateResult.map((row, key) => {
                    return (
                      <TableRow key={key} style={{ whiteSpace: "nowrap" }}>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.date}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {formatNumber.format(row.totalILog)}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {formatNumber.format(row.new)}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.percenNew !== null
                            ? formatNumber.format(row.percenNew.toFixed(1))
                            : 0}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {formatNumber.format(row.ptp)}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.percenPtp !== null
                            ? formatNumber.format(row.percenPtp.toFixed(3))
                            : 0}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {formatNumber.format(row.callback)}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.percenCallback !== null
                            ? formatNumber.format(row.percenCallback.toFixed(3))
                            : 0}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {formatNumber.format(row.ni)}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.percenNi !== null
                            ? formatNumber.format(row.percenNi.toFixed(3))
                            : 0}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {formatNumber.format(row.nmq)}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.percenNmq !== null
                            ? formatNumber.format(row.percenNmq.toFixed(3))
                            : 0}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {formatNumber.format(row.wr)}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.percenWr !== null
                            ? formatNumber.format(row.percenWr.toFixed(3))
                            : 0}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {formatNumber.format(row.vm)}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.percenVm !== null
                            ? formatNumber.format(row.percenVm.toFixed(3))
                            : 0}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {formatNumber.format(row.dnd)}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.percenDnd !== null
                            ? formatNumber.format(row.percenDnd.toFixed(3))
                            : 0}
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </Paper>
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

CampaignReportDetail.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  campaignDetail: state.reportCampaign.campaignDetail,
  listCampaignByAgent: state.reportCampaign.campaignByAgent,
  listCampaign: state.campaign.campaigns,
  listAgentGroups: state.agent.groupAgent,
  listCampaignByDate: state.reportCampaign.campaignByDate,
  loading: state.reportCampaign.loading,
});
const AgentAction = connect(null, agentAction)(CampaignReportDetail);
CampaignReportDetail = connect(mapStateToProps, mapActionsToProps)(AgentAction);
const CampaignAction = connect(null, campaignAction)(CampaignReportDetail);

export default withStyles(styles)(CampaignAction);
